const mainMenuSelectors = document.querySelectorAll('.main--menu p');

const initMainMenuInteractions = () => {
  const mainWrapper = document.querySelector('.main-wrapper');

  if (!mainWrapper) {
    return;
  }
  mainMenuSelectors.forEach(selector => {
    selector.addEventListener('click', () => {
      mainWrapper.classList.toggle('active-menu');
    });
  });
};

mainMenuSelectors && initMainMenuInteractions();
